import React from 'react';

import { Link } from '@rbilabs/universal-components';
import { useBreakpointValue } from 'native-base';
import { StyleSheet } from 'react-native';

import { Box, Typography } from 'components/ui';
import type { BoxProps, TypographyProps } from 'components/ui';
import { getDesignToken, spacing } from 'styles/constants';

export const CardContainer = ({ style, ...props }: BoxProps) =>
  React.createElement(Box, {
    ...props,
    style: [styles.cardContainer, style],
  });

export const ItemName = ({ style, ...props }: TypographyProps) => {
  const fontSize = useBreakpointValue({
    base: 'xs',
    md: 'md',
  });
  const height = useBreakpointValue({
    base: undefined,
    md: spacing.$8,
  });
  const width = useBreakpointValue({
    base: '100%',
    md: '50%',
  });

  return React.createElement(Typography, {
    ...props,
    fontFamily: 'heading',
    fontSize: fontSize ?? 'xs',
    lineHeight: '2xs',
    mt: '$1',
    style: [height ? { height } : undefined, { width }, style],
  });
};

export const StyledLink = Link.withConfig({
  _web: {
    width: 'fit-content',
    cursor: 'pointer',
    _hover: {
      _text: {
        color: getDesignToken('color-tertiary'),
      },
    },
  },
});

export const ActionWrapper = ({ style, ...props }: BoxProps) =>
  React.createElement(Box, {
    ...props,
    style: [styles.actionWrapper, style],
  });

export const Details = ({ style, ...props }: BoxProps) =>
  React.createElement(Box, {
    ...props,
    style: [styles.details, style],
  });

const styles = StyleSheet.create({
  actionWrapper: {
    alignSelf: 'flex-end',
    marginLeft: spacing.$4,
  },
  cardContainer: {
    alignItems: 'center',
    backgroundColor: getDesignToken('background-pattern'),
    borderRadius: spacing.$2,
    flexDirection: 'row',
    paddingHorizontal: spacing.$4,
    paddingVertical: spacing.$4,
    width: '100%',
  },
  details: {
    flex: 1,
    marginLeft: spacing.$4,
  },
});
